import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LanguageContext";

export const Brand = ({ className = "" }) => (
  <Link to="/" className={`flex items-center ${className}`} data-testid="brand-logo">
    <img src="/domifood-logo.png" alt="Domifood" className="h-9 w-auto" />
  </Link>
);

const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center rounded-full bg-neutral-100 p-0.5 text-xs font-semibold" data-testid="lang-toggle">
      {["en", "es"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`px-3 py-1 rounded-full transition-colors ${lang === l ? "bg-foreground text-background" : "text-neutral-500 hover:text-foreground"}`}
          data-testid={`lang-${l}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export const PublicNav = () => {
  const { t } = useLang();
  const links = [
    { to: "/#plataforma", label: t.nav.platform },
    { to: "/soporte", label: t.nav.support },
    { to: "/privacidad", label: t.nav.privacy },
    { to: "/contacto", label: t.nav.contact },
  ];
  return (
    <nav className="sticky top-0 z-40 bg-background/85 backdrop-blur-xl">
      <div className="max-w-6xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Brand />
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.to} href={l.to} className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              {l.label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <LangToggle />
          <Link to="/login">
            <Button variant="outline" className="rounded-full font-semibold px-5 border-border" data-testid="nav-login-btn">{t.nav.access}</Button>
          </Link>
        </div>
      </div>
    </nav>
  );
};
